export const numberWithDec = (value, dec = 1) => {
  return Number(value || 0).toFixed(dec);
};
